var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tablePage',_vm._b({},'tablePage',{defsEndpoint: _vm.endpoint, title: _vm.title},false))}
var staticRenderFns = []

export { render, staticRenderFns }